import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Spinner, ErrorBox, Progress, DataTable, Status, Risk, BudgetStatus,
  fmtDate, num, money } from '../components/ui';
export default function ProgrammeDetail() {
  const { can } = useAuth();
  const nav = useNavigate();
  const { id } = useParams();
  const [p, setP] = useState(null); const [err, setErr] = useState(null);
  useEffect(() => { setP(null); api.get(`/programmes/${id}`).then(r=>setP(r.data)).catch(setErr); }, [id]);
  if (err) return <ErrorBox error={err} />;
  if (!p) return <Spinner />;
  return <>
    <div className="phead">
      <div><h1 style={{marginBottom:2}}>{p.programme_name} <span className={`badge ${p.programme_type}`}>{p.programme_type}</span></h1>
        <div className="muted">{p.reference} · Start date {fmtDate(p.start_date)} · Expected end date {fmtDate(p.expected_end_date)} · <Link to="/programmes">all programmes</Link></div></div>
    </div>
    <div className="stat-grid">
      <div className="stat static"><div className="label">Projects (Sites)</div><div className="value">{num(p.project_count)}</div></div>
      <div className="stat static"><div className="label">Buildings</div><div className="value">{num(p.building_count)}</div><div className="sub">{num(p.hrb_buildings)} HRB / {num(p.lrb_buildings)} LRB</div></div>
      <div className="stat static"><div className="label">Avg progress</div><div className="value">{Number(p.avg_progress||0).toFixed(0)}%</div></div>
      <div className="stat static over"><div className="label">Delayed tasks</div><div className="value">{num(p.delayed_substages)}</div></div>
      <div className="stat static soon"><div className="label">Projects at risk</div><div className="value">{num(p.projects_at_risk)}</div><div className="sub">approaching or past their end date</div></div>
    </div>
    {Number(p.projects_at_risk) > 0 && (
      <div className="alert warn">
        <strong>{num(p.projects_at_risk)} project{Number(p.projects_at_risk)===1?'':'s'} at risk.</strong>{' '}
        {Number(p.projects_at_risk)===1?'One project is':'These projects are'} approaching or already past the expected end date — see the Risk column below.
      </div>
    )}

    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, alignItems:'start'}}>
      <div className="panel">
        <h3>Appointments</h3>
        <table className="data"><tbody>
          {[['Client', p.client_name],
            ['Main contractor', p.contractor_name],
            ['BRPD', p.brpd_name],
            ['Fire engineer', p.fire_engineer_name],
            ['Architect / lead designer', p.architect_name],
            ['Drylining consultant', p.drylining_name]].map(([role, org]) => (
            <tr key={role}><td style={{width:'46%',color:'var(--muted)'}}>{role}</td>
              <td>{org || <span className="muted">Not appointed</span>}</td></tr>
          ))}
        </tbody></table>
      </div>
      <div className="panel">
        <h3>Budget</h3>
        <table className="data"><tbody>
          <tr><td style={{width:'46%',color:'var(--muted)'}}>Budgeted across projects</td><td><strong>{money(p.budget_amount)}</strong></td></tr>
          <tr><td style={{color:'var(--muted)'}}>Total spent</td><td>{money(p.total_spent)}</td></tr>
          <tr><td style={{color:'var(--muted)'}}>Balance</td><td className={Number(p.balance)<0?'neg':''}>{money(p.balance)}</td></tr>
        </tbody></table>
        <div style={{marginTop:10}}><Link className="btn" to="/budget">Budget &amp; expenditure</Link></div>
      </div>
    </div>

    <div className="panel"><div className="phead"><h2>Projects (Sites)</h2>{can('project.create') && <button className="primary" onClick={()=>nav(`/programmes/${id}/projects/new`)}>+ New project</button>}</div>
      <DataTable rows={p.projects} columns={[
        { key:'project_name', label:'Project', render:(v,r)=><Link to={`/projects/${r.project_id}`}>{v}</Link> },
        { key:'buildings', label:'Total buildings', render:num },
        { key:'hrb', label:'HRB', render:num },
        { key:'lrb', label:'LRB', render:num },
        { key:'start_date', label:'Start date', render:fmtDate },
        { key:'expected_end_date', label:'Expected end date', render:fmtDate },
        { key:'progress_status', label:'Status', render:v=><Status value={v}/> },
        { key:'risk_level', label:'Risk', render:v=><Risk value={v}/> },
        { key:'progress', label:'Progress', render:v=><Progress value={v}/> },
        { key:'budget_amount', label:'Budget', render:money },
        { key:'budget_status', label:'Budget status', render:v=><BudgetStatus value={v}/> }
      ]}/>
    </div>
  </>;
}
